import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LayaSignUpModal from './components/LayaSignUpModal';
import LayaLogInModal from './components/LayaLogInModal';
import LayaForgotPasswordModal from './components/LayaForgotPasswordModal';
import Button from 'flarum/common/components/Button';
import LayaSSO from './components/LayaSSO';
import QRCodeWidget from './components/QRCodeWidget';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import EditUserModal from 'flarum/common/components/EditUserModal';
import TextEditor from 'flarum/common/components/TextEditor';
import insertText from 'flarum/common/utils/insertText';

// 在光标位置插入三反引号代码块，保证前后各有空行以符合 Markdown fenced code block 规范
function insertCodeBlock(textarea: HTMLTextAreaElement) {
  textarea.focus();
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;
  const value = textarea.value;
  const before = value.slice(0, start);
  const selected = value.slice(start, end);
  const after = value.slice(end);

  const newlinesBefore = (before.match(/\n*$/) || [''])[0].length;
  const leading = /\S/.test(before) ? '\n'.repeat(Math.max(0, 2 - newlinesBefore)) : '';

  const newlinesAfter = (after.match(/^\n*/) || [''])[0].length;
  const trailing = /\S/.test(after) ? '\n'.repeat(Math.max(0, 2 - newlinesAfter)) : '';

  const openFence = '```\n';
  const closeFence = '\n```';
  const text = leading + openFence + selected + closeFence + trailing;

  const cursorStart = start + leading.length + openFence.length;
  const cursorEnd = selected.length > 0 ? cursorStart + selected.length : cursorStart;

  insertText(textarea, { text, selectionStart: cursorStart, selectionEnd: cursorEnd });
}

app.initializers.add('laya-auth', () => {
  const sso = new LayaSSO();

  // 将编辑用户弹窗中的用户名字段设为只读
  extend(EditUserModal.prototype, 'fields', function (items) {
    if (items.has('username')) {
      const usernameField = items.get('username');
      items.replace('username',
        m('.Form-group', [
          m('label', app.translator.trans('core.lib.edit_user.username_heading')),
          m('input.FormControl', {
            type: 'text',
            value: this.username(),
            disabled: true,
            readonly: true
          })
        ])
      );
    }
  });

  // 让「登录以回复」按钮使用与右上角一致的 LayaLogInModal，保证登录弹窗一致
  const originalReplyAction = DiscussionControls.replyAction;
  console.log("测试tag版本 v0.0.3");
  DiscussionControls.replyAction = function (goToLast: boolean, forceRefresh: boolean) {
    const self = this;
    return new Promise((resolve, reject) => {
      if (app.session.user) {
        return originalReplyAction.call(self, goToLast, forceRefresh).then(resolve, reject);
      }
      app.modal.show(LayaLogInModal);
      reject();
    });
  };

  // 让首页「发布主题/发布提问」按钮使用与右上角一致的 LayaLogInModal
  override(IndexPage.prototype, 'newDiscussionAction', function (original) {
    return new Promise((resolve, reject) => {
      if (app.session.user) {
        app.composer.load(DiscussionComposer, { user: app.session.user });
        app.composer.show();
        return resolve(app.composer);
      } else {
        app.modal.show(LayaLogInModal);
        return reject();
      }
    });
  });

  // 添加二维码组件到页面
  // 添加二维码组件到页面
  extend(IndexPage.prototype, 'contentItems', function(items) {
    // 判断当前是否是首页
    if (app.current.matches(IndexPage)) {
      // 在讨论列表下方添加二维码组件
      items.add('qrcode', m(QRCodeWidget), -10);
    }
  });

  // extend(app, 'mount', function () {
  //   // 在页面body中添加二维码组件
  //   const qrContainer = document.createElement('div');
  //   qrContainer.className = 'Cooperate';
  //   document.body.appendChild(qrContainer);
  //   m.mount(qrContainer, QRCodeWidget);
  // });
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (items.has('signUp')) {
      items.replace('signUp',
        m(Button, {
          className: 'Button Button--link',
          onclick: () => app.modal.show(LayaSignUpModal)
        }, app.translator.trans('core.forum.header.sign_up_link'))
      );
    }

    if (items.has('logIn')) {
      items.replace('logIn',
        m(Button, {
          className: 'Button Button--link',
          onclick: () => app.modal.show(LayaLogInModal)
        }, app.translator.trans('core.forum.header.log_in_link'))
      );
    }
    sso.login();
  });


});

// 改造「行内代码」按钮：点击后直接插入三反引号代码块。
// 原因：单反引号只支持单行代码，用户往往会把多行代码（尤其含 @、{}、缩进等）粘进 `` 中间，
// 这会触发 mentions/emphasis/indent-code 等 Markdown 规则，导致渲染样式错乱。
// 注：使用更低的初始化优先级，确保在 flarum-markdown 之后执行，此时 markdownToolbarItems 才存在。
app.initializers.add('laya-auth-code-block', () => {
  if (!(TextEditor.prototype as any).markdownToolbarItems) {
    return;
  }

  override(TextEditor.prototype as any, 'markdownToolbarItems', function (original: Function) {
    const items = original();
    if (items.has('code')) {
      const codeVnode: any = items.get('code');
      if (codeVnode && codeVnode.attrs) {
        codeVnode.attrs.onclick = () => {
          const textarea: HTMLTextAreaElement = (this as any).attrs.composer.editor.el;
          insertCodeBlock(textarea);
        };
      }
    }
    return items;
  });
}, -10);



